import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MascotPortrait } from "@/components/Mascot";
import { MwpBadge, MWP_TIERS } from "@/components/MwpBadge";
import { useGame } from "@/context/GameContext";

const ORDER = ["bronze", "silver", "gold", "platinum"];
const rank = (t) => ORDER.indexOf(t);

export default function MwpTierAlert() {
  const { user, game } = useGame();
  const [up, setUp] = useState(null);
  const tier = game?.wallet?.mwp?.tier || null;
  useEffect(() => {
    if (!user?.user_id || !game) return;
    const key = `mwp_tier_seen_${user.user_id}`;
    const seen = localStorage.getItem(key) || null;
    if (tier && rank(tier) > rank(seen)) setUp(tier);
    if (tier !== seen) tier ? localStorage.setItem(key, tier) : localStorage.removeItem(key);
  }, [user?.user_id, tier, game]);
  const [clear, setClear] = useState(false);
  useEffect(() => {
    if (!up || clear) return;
    // wait until other pop-ups (tutorial, welcome bonus, daily reward) are closed
    const t = setInterval(() => !document.querySelector('[role="dialog"]') && setClear(true), 800);
    return () => clearInterval(t);
  }, [up, clear]);
  if (!up || !clear) return null;
  const t = MWP_TIERS[up];
  return (
    <Dialog open onOpenChange={(o) => !o && (setUp(null), setClear(false))}>
      <DialogContent data-testid="mwp-tier-alert" className="glass max-w-md text-center">
        <div className="mx-auto mt-2 chest-pop"><MascotPortrait size="w-24 h-24" /></div>
        <p className="text-[11px] font-mono-game text-amber-300 tracking-[0.3em] mt-2">KING WOLF SAYS</p>
        <DialogTitle className="font-display text-3xl text-amber-100">You've reached {t.label}!</DialogTitle>
        <div className="flex justify-center my-1"><MwpBadge tier={up} big testid="mwp-tier-alert-badge" /></div>
        <DialogDescription className="text-slate-300 leading-relaxed">
          Your $MWP holding earned the {t.label} badge. From now on you get +{t.bonus}% credits from battles, quests and login{up === "platinum" ? ", and a crown frame around your portrait everywhere" : ""}.
        </DialogDescription>
        <button data-testid="mwp-tier-alert-ok" onClick={() => { setUp(null); setClear(false); }} className="ember-btn w-full py-3 rounded-full text-sm mt-2">HOWL!</button>
      </DialogContent>
    </Dialog>
  );
}
